import React from 'react';
import { useHistory } from 'react-router';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

import AuthService from '../../services/AuthService';
import { RouterPaths } from '../../constants/routes';
import { AUTH_LOGIN_URL, EXTERNAL_LINKS } from '../../app-config';
import { DSButton } from '../Button/Button';
import NavDrawer from './NavDrawer';
import { useNavHeaderStyles } from './styles';
import NavLogo from '../../assets/icons/NavLogo';

interface PropsType {
  drawerOpen: boolean;
  handleDrawerToggle: Function;
}

const NavHeader: React.FC<PropsType> = ({ drawerOpen, handleDrawerToggle }) => {
  const history = useHistory();
  const classes = useNavHeaderStyles();
  const theme = useTheme();

  const onCreateAccountClicked = () => history.push(RouterPaths.signup);

  const onHomeIconClicked = () =>
    history.push(AuthService.loggedIn() ? RouterPaths.dashboard : RouterPaths.home);

  return (
    <>
      <div className={classes.container}>
        <div className={classes.wrapper}>
          <div className={classes.row}>
            <div className={classes.logo} role="button" onClick={onHomeIconClicked}>
              <NavLogo fill={theme.palette.text.primary} />
            </div>
            <Typography variant="h6">for developers</Typography>
          </div>

          <div className={classes.links}>
            <a href={EXTERNAL_LINKS.dataswiftDocs} target="_blank" rel="noopener noreferrer">
              <Typography color="textPrimary" variant="h6">
                Docs
              </Typography>
            </a>
            <a href={EXTERNAL_LINKS.datasiwftAPI} target="_blank" rel="noopener noreferrer">
              <Typography color="textPrimary" variant="h6">
                API
              </Typography>
            </a>
            <a href={EXTERNAL_LINKS.hubGithub} target="_blank" rel="noopener noreferrer">
              <Typography color="textPrimary" variant="h6">
                Github
              </Typography>
            </a>
          </div>

          <div className={classes.spacer} />

          <div className={classes.links}>
            <a className={classes.login} href={AUTH_LOGIN_URL}>
              <Typography variant="h6">Log in</Typography>
            </a>

            <DSButton
              className={classes.createAccount}
              onClick={() => history.push(RouterPaths.signup)}
            >
              Create Account
            </DSButton>
          </div>

          <IconButton
            className={classes.burger}
            aria-label="Toggle Drawer"
            edge="start"
            onClick={() => handleDrawerToggle()}
          >
            {drawerOpen ? (
              <i className="material-icons">close</i>
            ) : (
              <i className="material-icons">menu</i>
            )}
          </IconButton>
        </div>
      </div>
      {drawerOpen && <NavDrawer onCreateAccount={onCreateAccountClicked} />}
    </>
  );
};

export default NavHeader;
